export const UNIFIED_TABLE_CLASSNAMES = {
  wrapper: 'p-0 shadow-small',
  th: 'bg-default-100 text-default-400 text-xs font-semibold',
  td: 'text-sm py-2 px-3',
  tr: 'border-b border-default-100 hover:bg-default-50',
};

export const SUMMARY_ROW_CLASS = 'bg-default-100 font-semibold border-b-2 border-default-200';

export const TH_BASE_CLASS = 'py-2 px-3 text-default-400 text-xs font-semibold cursor-pointer select-none group/th';

export interface TableExportRef {
  exportToExcel: () => void;
}
